import type { I2VMode, I2VModelId } from "@saas/image-to-video/types";

/**
 * 首页 hero 下拉的模型，便宜在前，按各 tab 支持的过滤。四档 Seedance 和
 * /seedance-2-ai-video-generator、/start-end-frame-video 用同一组 id（同一套后端配置，
 * 2026-10-03 老公定），取代原来公共下拉里的 basic-between / master-3.0——那两个和
 * Seedance 2.0 Mini / 2.0 走同一个上游，留在列表里会出现两条同名项。
 * /image-to-video 的下拉 2026-10-06 起也用这份名单（老公定，两页模型补齐一致）
 * Veo 3.1 三档、Wan 3.0 两档各自挨着放：下拉里合成一条、档位在旁边胶囊里切（见 I2V_MODEL_FAMILIES）
 */
export const HOME_HERO_MODELS: readonly I2VModelId[] = [
	"basic",
	"seedance-2-mini",
	"fast-2.0",
	"veo-3.1-fast",
	"veo-3.1-quality",
	"fast-3.0",
	"quality-2.0",
	"quality-2.0-ref",
	"quality-2.0-text",
	"wan-3.0",
	"wan-3.0-prime",
	"quality-3.0",
	"seedance-2-fast",
	"master-2.0",
	"master-2.0-text",
	"master-2.0-ref",
	"kling-4.0",
	"kling-4.0-ref",
	"seedance-2",
	"seedance-2.5",
];

/**
 * 首页各 tab 表单里的模型不在名单时拉回哪档。start / text 同 DEFAULT_I2V_MODEL，
 * between 不能用 DEFAULT 的 basic-between（不在名单里），换成四档里的 Mini；
 * reference 同 DEFAULT_I2V_MODEL（basic 不支持参考图）
 */
export const HOME_HERO_FALLBACK_MODEL: Record<I2VMode, I2VModelId> = {
	start: "basic",
	text: "basic",
	between: "seedance-2-mini",
	reference: "fast-3.0",
};
